"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.whatsapp.group': 'Grupo de WhatsApp',
    'route.whatsapp.group.create': 'Agregar grupo de WhatsApp',
    'route.whatsapp.dm': 'Contacto DM de WhatsApp',
};
